import React from 'react';
import { FadeIn } from './FadeIn';
const steps = [{
  num: '1',
  title: 'Limpieza',
  desc: 'Sigues la lista de compras y eliminas los 4 disparadores inflamatorios de tu cocina.'
}, {
  num: '2',
  title: 'Ejecución',
  desc: 'Aplicas el menú del Día 1, 2 y 3 siguiendo el protocolo de hidratación y descanso.'
}, {
  num: '3',
  title: 'Reinicio',
  desc: 'En la mañana del cuarto día, despiertas con el abdomen plano, energía renovada y claridad mental.'
}];
export function StepsSection() {
  return <section className="py-12 md:py-24 bg-cream" data-id="element-348">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-349">
        <FadeIn data-id="element-350">
          <div className="text-center mb-8 md:mb-16" data-id="element-351">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-352">
              Cómo funciona el proceso
            </h2>
            <p className="text-lg text-gray-600" data-id="element-353">
              Tres pasos simples para recuperar el control de tu cuerpo.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-354">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-mint z-0" data-id="element-355"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-356">
              <div className="flex flex-col items-center text-center" data-id="element-357">
                <div className="w-24 h-24 rounded-full bg-white border-4 border-mint flex items-center justify-center text-3xl font-serif font-bold text-sage shadow-sm mb-6" data-id="element-358">
                  {step.num}
                </div>
                <h3 className="text-2xl font-bold text-forest mb-4 font-sans" data-id="element-359">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-360">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}